
import React from 'react';
import { AnalysisWidgetProps } from './WidgetTypes';
import FeatureErrorBoundary from '@/components/FeatureErrorBoundary';
import DeepPageAnalysisWidget from '@/components/DeepPageAnalysisWidget';

const DeepAnalysisWidget: React.FC<AnalysisWidgetProps> = ({
  crawlResult,
  selectedPageUrl,
  widgetRef,
  onRetry
}) => {
  return (
    <div ref={widgetRef} className="pt-8" id="deep-analysis" data-testid="widget-deep-analysis">
      <FeatureErrorBoundary 
        componentName="Deep Page Analysis Widget" 
        onRetry={onRetry}
      >
        <DeepPageAnalysisWidget 
          result={crawlResult} 
          selectedPage={selectedPageUrl} 
        />
      </FeatureErrorBoundary>
    </div>
  );
};

export default DeepAnalysisWidget;
